// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip---Hg7V0","fadeInOpacity":"fadeInOpacity---RGtXC","text":"text---MKcyO","sub":"sub---jWb9z"};